const e = {
  base: "fa-spin"
};
export {
  e as loaderStyles
};
